type RuntimeEnv = {
  ENABLE_ROLE_SWITCHER: boolean;
};

const DEFAULT_RUNTIME_ENV: RuntimeEnv = {
  ENABLE_ROLE_SWITCHER: false,
};

const RUNTIME_ENV_URL = "/config/env.json";
const PRODUCTION_HOST = "workload.sfedu.ru";

declare global {
  interface Window {
    __RUNTIME_ENV__?: RuntimeEnv;
  }
}

let runtimeEnv = DEFAULT_RUNTIME_ENV;

export let isRoleSwitcherEnabled = runtimeEnv.ENABLE_ROLE_SWITCHER;

const applyRuntimeEnv = (nextRuntimeEnv: RuntimeEnv): RuntimeEnv => {
  runtimeEnv = nextRuntimeEnv;
  isRoleSwitcherEnabled = nextRuntimeEnv.ENABLE_ROLE_SWITCHER;
  return nextRuntimeEnv;
};

const toBoolean = (value: unknown): boolean => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }

  return false;
};

const normalizeRuntimeEnv = (value: unknown): RuntimeEnv => {
  const source = value && typeof value === "object" ? value : {};
  const env = source as Record<string, unknown>;

  return {
    ENABLE_ROLE_SWITCHER: toBoolean(env.ENABLE_ROLE_SWITCHER),
  };
};

const isProductionHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.location.hostname === PRODUCTION_HOST;
};

export const loadRuntimeEnv = async (): Promise<RuntimeEnv> => {
  if (typeof window === "undefined") {
    return DEFAULT_RUNTIME_ENV;
  }

  // На проде не запрашиваем env.json — только дефолты (ENABLE_ROLE_SWITCHER: false)
  if (isProductionHost()) {
    window.__RUNTIME_ENV__ = applyRuntimeEnv(DEFAULT_RUNTIME_ENV);
    return DEFAULT_RUNTIME_ENV;
  }

  try {
    const response = await fetch(RUNTIME_ENV_URL, { cache: "no-store" });

    if (!response.ok) {
      window.__RUNTIME_ENV__ = applyRuntimeEnv(DEFAULT_RUNTIME_ENV);
      return DEFAULT_RUNTIME_ENV;
    }

    window.__RUNTIME_ENV__ = applyRuntimeEnv(
      normalizeRuntimeEnv(await response.json()),
    );
    return window.__RUNTIME_ENV__;
  } catch {
    window.__RUNTIME_ENV__ = applyRuntimeEnv(DEFAULT_RUNTIME_ENV);
    return DEFAULT_RUNTIME_ENV;
  }
};
